var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "sidebarFilter" },
    [
      _c("p", { staticClass: "sidebarFilter__desc" }, [
        _vm._v(
          _vm._s(_vm.trans("EXTENDED_SEARCH_INDUSTRY_FILTER_DESCRIPTION"))
        ),
      ]),
      _vm._v(" "),
      _c("CustomDropdownB", {
        staticClass: "sidebarFilter__industryDropdown",
        attrs: {
          id: "inlineDropdown__industry",
          "data-gtm": "sidebarFilter__industry",
          value: _vm.ALL_VALUE,
          options: _vm.branchesData,
          element: "sidebarFilter__industry",
          bordered: true,
        },
        on: { changeValue: _vm.setIndustry },
      }),
      _vm._v(" "),
      _vm.selectedCategory !== [_vm.ALL_VALUE]
        ? _c("div", [
            _c("div", {
              staticClass: "hidden",
              domProps: { innerHTML: _vm._s(_vm.subCategoryHTML) },
            }),
            _vm._v(" "),
            _vm.subCategoryHTML.length > 0
              ? _c(
                  "div",
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "entity__headline entity__headline--dark margin-top-10",
                      },
                      [
                        _c("label", { attrs: { for: "subCategory" } }, [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.trans(
                                  "EXTENDED_SEARCH_INDUSTRY_FILTER_SUBCATEGORY"
                                )
                              ) +
                              "\n                "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.subCategoryHTML, function (subIndustry) {
                      return _c(
                        "label",
                        {
                          key: subIndustry.id,
                          staticClass:
                            "sidebarFilter__wrapperCheckBox sidebarFilter__wrapperIndustry",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "sidebarFilter__checkBox sidebarFilter__industryCheckBox",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedCategoriesPill,
                                    expression: "selectedCategoriesPill",
                                  },
                                ],
                                ref: "checkbox",
                                refInFor: true,
                                staticClass: "customCheckboxInput",
                                attrs: {
                                  "data-gtm": `sidebarFilter__subIndustry--option${subIndustry.id}`,
                                  type: "checkbox",
                                  multiple: true,
                                },
                                domProps: {
                                  value: subIndustry,
                                  checked: subIndustry.isChecked,
                                  checked: Array.isArray(
                                    _vm.selectedCategoriesPill
                                  )
                                    ? _vm._i(
                                        _vm.selectedCategoriesPill,
                                        subIndustry
                                      ) > -1
                                    : _vm.selectedCategoriesPill,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = _vm.selectedCategoriesPill,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = subIndustry,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.selectedCategoriesPill =
                                              $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.selectedCategoriesPill = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.selectedCategoriesPill = $$c
                                      }
                                    },
                                    function ($event) {
                                      _vm.setSubIndustry(subIndustry)
                                      _vm.setSelectedSubIndustries(
                                        subIndustry.label
                                      )
                                    },
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "customCheckbox" }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(subIndustry.label) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "selectedSubIndustries flex",
          class: _vm.selectedCategoriesPill < 1 ? "hidden" : "",
        },
        _vm._l(_vm.selectedCategoriesPill, function (subIndustryPill) {
          return _c(
            "div",
            {
              key: subIndustryPill.label,
              staticClass: "subIndustryPill__wrapper",
            },
            [
              subIndustryPill.parentId !== null
                ? _c(
                    "button",
                    {
                      staticClass:
                        "facetedSearch__tag facetedSearch__tag--selected flex flex__alignItems--center",
                      attrs: {
                        type: "button",
                        "data-gtm": `subIndustryPill__${subIndustryPill.label}`,
                        "aria-label": `subIndustryPill--${subIndustryPill.label}`,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.removeSubIndustry(subIndustryPill)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(subIndustryPill.label) +
                          "\n                "
                      ),
                      _c(
                        "svg",
                        {
                          staticClass: "pill__icon",
                          attrs: {
                            height: "16",
                            width: "16",
                            "aria-hidden": "true",
                          },
                        },
                        [_c("use", { attrs: { href: "#iconCrossBold" } })]
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "selectedIndustries flex facetedSearch__content",
          class: _vm.selectedCategoriesPill < 1 ? "hidden" : "",
        },
        _vm._l(_vm.categoriesArray, function (subIndustryPill) {
          return _c(
            "button",
            {
              key: subIndustryPill.label,
              staticClass:
                "facetedSearch__tag facetedSearch__tag--mobile flex flex__alignItems--center",
              attrs: {
                type: "button",
                "data-gtm": `subIndustryPill__${subIndustryPill.label}`,
                "aria-label": `subIndustryPill--${subIndustryPill.label}`,
              },
              on: {
                click: function ($event) {
                  return _vm.removeSubIndustry(subIndustryPill)
                },
              },
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(subIndustryPill.label) +
                  "\n            "
              ),
              _c(
                "svg",
                {
                  staticClass: "pill__icon",
                  attrs: { height: "16", width: "16", "aria-hidden": "true" },
                },
                [_c("use", { attrs: { href: "#iconCrossBold" } })]
              ),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }